import { Card } from 'antd';
import styled from 'styled-components';

const ACTIVE_COLOR = '#2CC852';
const INATIVE_COLOR = '#E74150';
const FULL_WIDTH_CARD_MAX = '18.75rem';

interface IContainerProps {
	$isActive: boolean;
	$fullWidth?: boolean;
}

export const Container = styled(Card)<IContainerProps>`
	.ant-card-body {
		padding: 10px 16px 10px 16px;
		width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
	}

	.ant-space {
		gap: 0 !important;
	}
	margin-top: 10px;
	width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
	min-width: ${({ $fullWidth }) => ($fullWidth ? 'unset' : '55%')};
	max-width: ${({ $fullWidth }) => ($fullWidth ? FULL_WIDTH_CARD_MAX : 'none')};
	height: fit-content;
	border-radius: 5px;
	color: ${({ $isActive }) => ($isActive ? ACTIVE_COLOR : INATIVE_COLOR)};
	border-color: ${({ $isActive }) => ($isActive ? ACTIVE_COLOR : INATIVE_COLOR)};
	:hover {
		border-color: ${({ $isActive }) => ($isActive ? ACTIVE_COLOR : INATIVE_COLOR)};
	}
`;
